import { getFileExtension } from './file'

/**
 * 去掉 base64 字符串前面的前缀
 * console.log(removeBase64Prefix('data:image/png;base64,iVBORw0KGgoAAAAN')) iVBORw0KGgoAAAAN
 * console.log(removeBase64Prefix('iVBORw0KGgoAAAAN')) iVBORw0KGgoAAAAN
 * @param data
 */
export const removeBase64Prefix = (data: string) => {
  return data.replace(/^data:\S+;base64,/, '')
}

export const dataURIPrefix: {
  [key: string]: string
} = {
  jpg: 'data:image/jpeg;base64,',
  png: 'data:image/png;base64,',
  jpeg: 'data:image/jpeg;base64,'
}

/**
 * 添加 base64 数据前缀，转换为 dataURI
 * @param data
 * @param ext 文件扩展名，如 png
 */
export const addDataURIPrefix = (data: string, ext: string) => {
  return dataURIPrefix[ext] + data
}

export const addDataURIPrefixForFiles = (files: {
  name: string;
  data: string
}[]): {
  name: string;
  data: string
}[] => {
  return files.map(item => {
    return {
      name: item.name,
      data: dataURIPrefix[getFileExtension(item.name)] + item.data
    }
  })
}
